import React from 'react';
import { withLocalize } from "react-localize-redux";

class NotFoundComponent extends React.Component {
    render() { 
        return (<div>Not Found</div>)
    }
}
export default withLocalize(NotFoundComponent);
